import { business, interfaceURL } from '@/config/index';
import fly from 'flyio';
import { reportAegisError } from '@/utils/aegis';
import uuid from 'uuid';
import { sourceNingxiaUrl, Message } from '@/utils/utils';
import { MessageBox } from 'element-ui';
const loginBlacklist = ['/sso'];

const reportError = (request, error = '') => {
  const options = {
    url: request?.url || '',
    body: request?.body || {},
    headers: request.headers || {},
  };
  reportAegisError({
    type: 'REQUEST_ERROR',
    error: error.toString() !== '[object Object]' ? error.toString() : JSON.stringify(error),
    extra: {
      ...options,
    },
  });
};

const ERROR = {
  100: '请先登录',
  101: '没有权限',
};

fly.config.baseURL = `${interfaceURL}`;

fly.interceptors.request.use((request) => {
  const { hash } = window.location;
  // eslint-disable-next-line
  const resource_key = hash.match(/#([^\?]+)/) || [];
  request.body && (request.body.commonIn = { ...request.body.commonIn, requestId: uuid(), client: 'doctor_web' });
  request.headers['Auth-Token'] = `${business}:${resource_key[1]}`;
  request.headers.credentials = 'include';
});
fly.interceptors.response.use((response) => {
  try {
    // 后端直接返回二进制数据时，直接导出
    const isBuffer = response.request?.responseType === 'arraybuffer';
    /** buffer 返回了json认为是报错信息，因为正常buffer会返回二进制 */
    const isReturnJson = response.headers['content-type'].includes('application/json');
    if (isBuffer && response.status === 200 && !isReturnJson) {
      return response.data;
    }
    // 文件上传，避免报错
    if (response.request?.url.includes('myqcloud.com')) {
      return response.data;
    }
    // 只将请求结果的data字段返回
    let res = isBuffer ? JSON.parse(Buffer.from(response.data).toString('utf-8')) : response.data;
    if (res && typeof res === 'string') {
      res = JSON.parse(res);
    }
    const { code, message, data = {}, retMsg } = res;
    if (code === 0) {
      const { errCode = 0, errMsg, commonOut } = data;
      if (errCode !== 0) {
        if (errCode === -10017) {
          MessageBox.alert(errMsg, '系统提示', {
            confirmButtonText: '确定',
          });
          return {
            ...data,
          };
        }

        if (errCode !== -100) {
          Message.error(errMsg);
        }
        return {
          err: errMsg,
          ...data,
        };
      }
      if (commonOut && commonOut.resultCode !== 0) {
        Message.error(commonOut?.errMsg);
        return {
          err: commonOut?.errMsg,
          ...data,
        };
      }
      return data;
    }
    if (ERROR[code]) {
      const hashRouteParamsArr = window.location.hash?.split('?'); // 获取哈希路由和所带参数
      // 如果url不含重定向参数redirect，再进行重定向的判断。避免因并发请求返回多次未登录状态码导致多次重定向问题
      if (!hashRouteParamsArr[1]?.includes('redirect=') && !loginBlacklist.includes(hashRouteParamsArr[0])) {
        const locationUrl = sourceNingxiaUrl() ? 'dataAnalysisLogin' : 'login';
        if (code === 100 && response.request.url === '/hospital/getExpMatchList') {
          window.location = `/#/${locationUrl}?redirect=matchResult`;
        } else if (code === 100 && response.request.url.includes('/hospital/getPatientExpMatch')) {
          const hospitalPatientId = response.request.url.split('/').reverse()[0];
          window.location = `/#/${locationUrl}?redirect=matchResult/detail?hospitalPatientId=${hospitalPatientId}`;
        } else if (code === 100 && hashRouteParamsArr[0] === '#/default/toolsInHospitalMessage') {
          window.location = `/#/${locationUrl}?redirect=default/toolsInHospitalMessage?${hashRouteParamsArr[1]}`; // 跳转院内消息下发页面
        } else if (ERROR[code] && response.request.url !== '/hospital/patientVerification') {
          window.location = `/#/${locationUrl}`;
          // Message.error(message || retMsg);
        }
        if (hashRouteParamsArr[0] !== `#/${locationUrl}`) {
          throw new Error('弹窗拦截');
        }
      }
    } else {
      Message.error({
        message: message || retMsg,
        duration: 10000,
      });
      if (
        !(
          (response.request.url === '/hospital/login' || response.request.url === '/hospital/changePasswd')
          && code === -1
        )
        && code !== -100
      ) {
        // 过滤掉密码不正确的情况和code为-100的情况
        reportError(response?.request, JSON.stringify({ code, message: message || retMsg }));
      }
    }
    return {
      code,
      err: message || retMsg,
    };
  } catch (e) {
    if (e.toString() === 'Error: 弹窗拦截') {
      throw new Error('弹窗拦截');
    }
  }
});

export default fly;
